import Templates from "../../templates";
import { OurWorkPage } from "../../organisms";
import Services from "./service";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const OurWork = () => {
  const {
    dataHeader,
    dataNews,
    addFeedback,
    dataBusiness,
  } = Services();
  const {pathname} = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(()=>{
    setLoading(false);
  },[]);

  useEffect(() =>{
    window.scrollTo({top: 0, behavior:"smooth"});
  }, [pathname])
  console.log('data business', dataBusiness);
  return(
    <Templates loading={loading}>
      <OurWorkPage
        dataNews={dataNews}
        dataHeader={dataHeader}
        dataBusiness={dataBusiness}
        sendFeedback={(e) => addFeedback(e)}
      />
    </Templates>
  )
}

export default OurWork;

// import Templates from "../../templates";
// import { OurWorkPage } from "../../organisms";
// const OurWork = () => {

//   return(
//     <Templates loading={false}>
//       <OurWorkPage/>
//     </Templates>
//   )
// }

// export default OurWork;